<template>
  <div>
    <!-- 单位 -->
    <div class="title">单位</div>
    <div class="mt15">
      <el-input v-model="keyInput" @change="changekeyinput" prefix-icon="el-icon-search" placeholder="请输入关键词可进行模糊查询"></el-input>
    </div>
    <el-tree class="zzjg" ref="tree" :data="treeData" node-key="id" :props="defaultProps" @node-click="handleNodeClick" default-expand-all :expand-on-click-node="false" accordion highlight-current>
      <span class="custom-tree-node" slot-scope="{ node, treedata }">
        <span class="tree_name">{{ node.label }}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  props: {
    queryType: Number
  },
  data () {
    return {
      keyInput: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'organizationName'
      },
      url: ''
    }
  },
  mounted () {
    this.url = Vue.prototype.global.Url_getUnitTree
    if (this.queryType === 1) {
      this.url = Vue.prototype.global.Url_getUnitAndProjectTree
    }
    this.getUnitTree()
  },
  methods: {
    changekeyinput (value) {
      if (value.length > 0) {
        this.findUnitByKeyWord(value)
      } else {
        this.getUnitTree()
      }
    },
    getUnitTree: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(that.url, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.treeData = response.data.data
            that.$nextTick(() => {
              var curid = that.treeData[0].id
              that.$refs.tree.setCurrentKey(curid)
              that.$emit('change', { id: curid })
            })
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    findUnitByKeyWord: function (keyword) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.keyword = keyword
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_findUnitByKeyWord, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.treeData = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleNodeClick (node) {
      console.log(node)
      this.$emit('change', node)
    }
  }
}
</script>

<style lang="less" scoped>
.zzjg{
  margin-top: 15px;
  /deep/ .el-tree-node__expand-icon {
    color: #4976ff;
  }
}

/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4976ff;
  border-left: 2px solid #4976ff;
  background-color: #fff;
}

.tree_name,.tree_num{
  display: inline-block;
}

.tree_num{
  margin-left: 10px;
  padding: 2px 6px;
  background: #f6f6fa;
  border-radius: 4px;
}

// 控制行高
/deep/ .el-tree-node__content{
  margin-top: 10px;
}
</style>
